import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/master/aboutme/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import Add_section_title from "../../../common-components/add-section-title/Add_section_title";
import { getDimension } from "../../../../utils/common";
import { Row } from "react-bootstrap";

const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    watch,
    setError,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const imageFile = watch("icon");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("title", data?.title);
      // sendData.append("description", data?.description);
      sendData.append("icon", data?.icon[0]);
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        setSuccess(true);
        setModalShow(true);
        await setId("");
        reset({ title: "" });
        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }
      if (response.meta.requestStatus === "rejected") {
        await setError("title", {
          type: "manual",
          message: "About Me already exists",
        });
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };
  return (
    <>
      <Add_section_title
        title={id ? "Edit About Me" : "Add About Me"}
        alltotal=""
      />
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name=""
                  placeholder="Name"
                  {...register("title", {
                    required: "Name is Required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.title,
                  })}
                />
                {errors.title && (
                  <span className="text-danger">{errors.title?.message}</span>
                )}
              </div>

              <div className="main-form-section mt-3">
                <Row className="justify-content-start">
                  <Form.Label className="text-left">icon</Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.icon,
                      })}
                      type="file"
                      {...register("icon", {
                        required:
                          typeof getValues("icon") == "string"
                            ? false
                            : " icon is required",
                        validate: async (value) => {
                          if (typeof value !== "string") {
                            const fileTypes = ["jpg", "png", "jpeg"];
                            const fileType = value[0].name?.split(".")[1];

                            if (!fileTypes.includes(fileType)) {
                              return `please upload a valid file format. (${fileTypes})`;
                            }

                            const sizes = await getDimension(value[0]);
                            // if (sizes.width !== 359 && sizes.height !== 157) {
                            //   return "icon width and height must be 359 px and 157 px";
                            // }

                            // const fileSize = Math.round(
                            //   value[0].size / 1024
                            // );
                            // if (fileSize > 500) {
                            //   return "file size must be lower than 500kb";
                            // }
                          }
                        },
                      })}
                      accept=".jpg, .jpeg, .png"
                    />
                  </Form.Group>
                  {errors.icon && (
                    <span className="text-danger">{errors.icon.message}</span>
                  )}
                </Row>
              </div>

              <Form.Group className="mb-3">
                <Form.Label className="text-center">icon Preview</Form.Label>
                {typeof getValues("icon") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IDS.IMG_URL + getValues("icon")}
                      alt="Preview"
                      className="image-preview"
                      style={{ width: "150px", height: "130px" }}
                    />
                  </div>
                ) : (
                  imageFile &&
                  imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  )
                )}
              </Form.Group>
            </div>
          </div>

          <div className="form_submit_div ">
            <div className="row">
              <div className="col-lg-4 mx-auto mb-3">
                <div className="button_group">
                  <button
                    type="button"
                    className="closebtn theme_bg"
                    onClick={() => {
                      reset({ name: "" });
                      setId("");
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="addbtn"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
